import { Component, Inject, OnInit } from '@angular/core';
import { NxDialogService, NX_MODAL_DATA } from '@aposin/ng-aquila/modal';
import { DownloadEvrotrustModalComponent } from '../download-evrotrust-modal/download-evrotrust-modal.component';
import { SignPolicyModalComponent } from '../sign-policy-modal/sign-policy-modal.component';

@Component({
  selector: 'app-evrotrust-general',
  templateUrl: './evrotrust-general.component.html',
  styleUrls: ['./evrotrust-general.component.scss']
})
export class EvrotrustGeneralComponent implements OnInit {

  hideHeader: boolean

  constructor( @Inject(NX_MODAL_DATA) public data: any  ) { }

  ngOnInit(): void {
    if(this.data.heading){
      this.hideHeader=true
    }
    else{
      this.hideHeader=false
    }
  }
}
